// extracted by mini-css-extract-plugin
module.exports = {"container":"Container_container__W4J6f","container--no-margin":"Container_container--no-margin__Tqq6b"};